var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPerson = function SvgPerson(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 591,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#43264A",
    d: "M250.401 42.527A38.38 38.38 0 0 1 275.079 68.8c3.009 12.126-1.575 26.496-10.542 35.186a40.843 40.843 0 0 1 1.677 32.599c-4.302 10.469-14.803 16.896-26.253 17.704a32.13 32.13 0 0 1-5.459 15.287 32.088 32.088 0 0 1-12.232 10.663 30.788 30.788 0 0 1-15.804 2.988 30.787 30.787 0 0 1-15.154-5.393 32.88 32.88 0 0 1-31.362 6.71c-10.603-3.456-17.853-13.582-19.327-24.414a34.308 34.308 0 0 1-33.361-11.621c-7.513-9.479-8.078-24.919-2.02-35.651-9.188-3.173-14.176-12.53-15.085-21.604-1.454-14.37 7.35-29.83 20.033-38.056a28.315 28.315 0 0 1-.762-16.745 28.296 28.296 0 0 1 8.84-14.237 33.484 33.484 0 0 1 33.382-5.174 33.316 33.316 0 0 1 10.684-11.57A33.28 33.28 0 0 1 177.135.106a34.488 34.488 0 0 1 15.44 2.333 34.52 34.52 0 0 1 12.833 8.904c8.905-4.972 21.729-4.042 30.615 1.354 8.885 5.396 14.923 19.907 14.378 29.83z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "m165.37 186.329.421-59.249h36.193l.775 59.923-37.389-.674z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4D1F1F",
    d: "M161.211 144.444c-1.92-5.238 12.547 24.303 27.553 22.366 12.867-1.684 15.04-24.808 15.04-24.808s-5.962 8.808-19.553 8.825c-15.141.034-23.04-6.383-23.04-6.383z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "M145.059 94.323c0 10.307 1.078 29.692 7.748 42.474 6.265 12.009 17.431 18.122 31.039 18.122s25.667-9.111 31.039-19.368c8.118-15.578 7.73-40.959 7.73-40.959s0-36.799-38.348-36.799c-40.403-.067-39.208 36.53-39.208 36.53z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "m175.157 92.555-20.985 5.44s.96-5.895 9.566-8.05c8.606-2.156 11.419 2.61 11.419 2.61zm13.474 0 21.035 5.44s-.96-5.895-9.566-8.05c-8.606-2.156-11.469 2.61-11.469 2.61z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    stroke: "#161311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.02,
    d: "m181.904 106.29-1.79 6.163a3 3 0 0 0 2.881 3.837H186"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M198.615 123.863H167.98s.876 11.267 15.242 11.301c13.238.016 15.393-11.301 15.393-11.301z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    stroke: "#161311",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.02,
    d: "M170.862 104.63s-5.827-2.964-10.745 0m44.209 0s-5.827-2.964-10.745 0"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B382BA",
    d: "M148.445 557.485s16.404-81.429 26.054-103.626a2.328 2.328 0 0 1 2.322-1.376 2.32 2.32 0 0 1 2.057 1.746c2.324 8.421 5.389 33.38 4.025 106.776V591h64.437l10.105-72.2c.522-5.524 21.203-95.998-30.77-165.773H125.81s-40.79 70.146-46.416 155.938C78.148 528.046 77.71 557.216 75.1 591h66.187l7.158-33.515z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    stroke: "#7E459B",
    strokeMiterlimit: 10,
    strokeWidth: 1.99,
    d: "m146.66 440.689 33.094 13.541"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD4C88",
    d: "M99.167 196.753s-21.12 2.998-36.58 55.915l41.633 23.864 24.555-33.784-29.608-45.995z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "M104.218 276.533s-27.654 43.351-34.205 51.132c-6.737 8.067-17.06 12.058-26.004 6.484a18.646 18.646 0 0 1-6.955-23.848l28.63-56.032 38.534 22.264z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "m37.46 196.821 33.094 107.703-35.3 15.343-21.22-121.446 23.426-1.6z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "m35.185 202.176 5.17-5.052a21.89 21.89 0 0 0 6.603-13.794l1.33-14.601s.842-7.697-14.45-5.76c-15.292 1.937-16.201 2.021-16.033 6.568 0 0 2.796 6.299 12.665 7.579l4.715 25.06z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "M15.817 204.416S.66 195.995.003 169.588a8.896 8.896 0 0 1 3.974-7.63c3.924-2.577 15.158-9.061 21.288-4.918l10.594 13.693-.674 31.443-19.368 2.24z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "m38.083 166.119 8.42-42.626a4.732 4.732 0 0 0-3.654-5.558 4.753 4.753 0 0 0-5.608 3.57l-7.444 32.235-3.57.691-12.362-32.623a4.319 4.319 0 0 0-4.035-2.788c-.581 0-1.157.118-1.692.346a4.31 4.31 0 0 0-2.458 5.053l12.125 45.169 20.278-3.469z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    stroke: "#5E3228",
    strokeMiterlimit: 10,
    d: "M38.739 162.75s-20.766-1.937-20.934 6.871c0 0-.438 6.619 12.664 7.579a12.296 12.296 0 0 0-8.572 11.436m37.221 78.668 8.791 28.597"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "M241.06 258.495s32.875 115.635 45.472 212.542l21.187-4.025s-3.234-141.993-24.606-229.822l-42.053 21.305z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "M307.548 462.279s31.881 47.157-6.383 68.226a6.102 6.102 0 0 1-7.579-1.364l-.236-.287a6.062 6.062 0 0 1 .404-8.235c5.44-5.507 12.749-16.926 1.095-31.848 0 0-6.114 1.567-5.053 13.709a5.043 5.043 0 0 1-3.298 5.167 5.063 5.063 0 0 1-2.158.29 5.046 5.046 0 0 1-4.396-3.806c-2.004-8-5.322-27.856 7.461-38.517l20.143-3.335z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD4C88",
    d: "M261.318 206.404s30.315 9.92 35.552 57.582l-49.144 18.643-11.081-30.315 24.673-45.91z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "#DD4C88",
    d: "m232.285 195.356 29.506 11.166-35.115 132.83H125.812L99.168 196.754l34.98-8.118 98.137 6.72z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "#1A1A1A",
    d: "M226.674 339.352H125.81v13.675h100.864v-13.675z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    stroke: "#C12D71",
    strokeMiterlimit: 10,
    strokeWidth: 1.99,
    d: "m112.051 265.738-7.831-35.503m139.988 42.795 10.593-39.561"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "#784B3F",
    d: "m193.463 179.878 38.736 15.477s-4.514 15.293-50.07 15.293c-39.696 0-48.067-22.012-48.067-22.012l37.726-8.758h21.675z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "#43264A",
    d: "M227 102.252a19.713 19.713 0 0 1-8.467-9.915 64.239 64.239 0 0 1-3.666-13.415 34.51 34.51 0 0 1-20.324-12.957 17.906 17.906 0 0 1-23.386-.477 26.01 26.01 0 0 1-21.204 11.455c.751 9.291-3.666 19.793-9.86 26.775V84.677a43.488 43.488 0 0 1 43.398-43.509 43.51 43.51 0 0 1 40.197 26.858A43.507 43.507 0 0 1 227 84.676v17.576z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "#E86164",
    d: "M183.49 33.947a43.485 43.485 0 0 0-30.758 12.745A43.495 43.495 0 0 0 140 77.456v14.423c0-24.008 19.463-49.226 43.49-49.226 23.954 0 43.509 25.218 43.509 49.226V77.456a43.518 43.518 0 0 0-12.744-30.765 43.515 43.515 0 0 0-30.765-12.744z"
  })));
};
export default SvgPerson;